import * as Yup from 'yup';

export const ValidationUpdateUserForm = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
});